export class Navigation {
    id: number;
    title: string;
    hint: string;
    sort_order: number;
}
